<template>
  <div class="connect-header-layout">
    <div class="customer-service-info">
      <img :src="avatar" alt @error="errorImg" />
      <div>
        <span class="nickname">{{ serverAlias }}</span>
        <span class="welcome">{{
          $customerConstant.CUSTOMER_CONSTANT.TITLE
        }}</span>
      </div>
    </div>
    <span>
      <span
        v-if="isProxy && isConversation"
        class="device-info"
        @click="showDeviceInfo"
        >设备信息</span
      >

      <span
        class="close"
        style="padding-right: 0!important;"
        @click="closeWindow"
        v-if="isConversation"
        ><i class="el-icon-switch-button"></i>&nbsp;&nbsp;结束会话</span
      >
      <span
        class="close"
        @click="closePage"
        v-if="!isConversation && isQueue && urlData.isEmbedded == 0"
        >退出排队</span
      >
    </span>
    <device-info
      :isShowDeviceInfo="isShowDeviceInfo"
      @closeDeviceDialog="isShowDeviceInfo = false"
    />
  </div>
</template>

<script>
import deviceInfo from "./dialogs/device-info";
import utils from "../../utils";
import constants from "src/app/customer/constant";

//询前页头部
export default {
  name: "connect-header",
  components: { deviceInfo },

  data() {
    return {
      defult_img: require("src/assets/imgs/server-avatar.jpg"),
      isShowDeviceInfo: false
    };
  },
  computed: {
    ...mapState({
      serverAlias: state => state.serverAlias,
      serverImage: state => state.serverImage,
      isConversation: state => state.isConversation,
      serverAvatar: state => state.serverAvatar,
      isQueue: state => state.isQueue,
      urlData: state => state.urlData,
      enterScene: state => state.enterScene
    }),
    isProxy() {
      const enterId = parseInt(this.enterScene, 10);
      const isDymaticProxyId = enterId > 7;
      return enterId === constants.WakeUpScene.proxy || isDymaticProxyId;
    },
    avatar() {
      return this.serverImage || this.serverAvatar;
    }
  },
  methods: {
    ...mapActions({
      closeWindow: "closeWindow"
    }),
    showDeviceInfo() {
      this.isShowDeviceInfo = true;
    },
    closePage() {
      utils.closePage();
    },
    errorImg() {
      this.$store.commit("setState", {
        serverAvatar: this.defult_img,
        serverImage: this.defult_img
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/:focus {
  outline: 0;
}
.form {
  width: 80%;
  margin: 10px auto;
}
.close {
  color: var(--connect-header-color);
  font-size: 12px;
  cursor: pointer;
}
.device-info {
  color: var(--connect-header-color);
  font-size: 12px;
  cursor: pointer;
  margin-right: 12px;
}
.connect-header-layout {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.customer-service-info {
  display: flex;
  align-items: center;

  img {
    width: 35px;
    height: 35px;
    margin-right: 5px;
    border-radius: 50%;
  }

  > div {
    display: flex;
    height: 35px;
    flex-wrap: wrap;
    align-items: flex-end;
    color: var(--connect-header-color);

    span {
      display: block;
      width: 100%;
    }
    .nickname {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
    .welcome {
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.el-icon-close {
  font-size: 22px;
  color: var(--connect-header-close-color);
  cursor: pointer;
}
</style>
